import cx from 'classnames';
import { intcomma } from 'journalize';
import { h, VNode } from 'preact';

import PureComponent from './PureComponent';

import formatPercent from '../utils/format-percent';
import { isCanvass } from '../endpoints';
import PartyPill from './PartyPill';

interface Props {
  ballotName: string;
  candidateId: string;
  contestIsCalled: boolean;
  contestResult: string;
  isIncumbent: boolean;
  isWinner: boolean;
  numDelegates: any | null;
  candidateColors: { [key: string]: any };
  party: string;
  totalVotesInContest: number;
  votes: number;
}

class HeadshotCandidateRow extends PureComponent<Props> {
  static columnCount: number;
  static Header: VNode;
  static Header_Prez: VNode;

  getColor(candidateColors, ballotName, party) {
    if (candidateColors.length === 0) {
      return party === 'Republican' ? '#EF564A' : '#1755c5';
    }

    const candidateMatch = candidateColors.find(
      colorObj => colorObj.name === ballotName
    );
    if (!candidateMatch) return party === 'Republican' ? '#EF564A' : '#1755c5';
    return candidateMatch.color;
  }

  render() {
    const {
      ballotName,
      candidateId,
      contestIsCalled,
      contestResult,
      isIncumbent,
      isWinner,
      party,
      isViewable,
      office,
      numDelegates,
      totalVotesInContest,
      candidateColors,
      votes,
    } = this.props;

    const color = this.getColor(candidateColors, ballotName, party);

    const divStyle = {
      'background-color': color,
    };

    const checkStyle = {
      color: color,
    };

    const IsAsterisk = false;

    let rowClass = cx(
      'candidate',
      'contest__candidate-row',
      'contest__candidate-row--headshot',
      {
        'contest__candidate-row--winner dem--border':
          contestIsCalled && isWinner && party == 'Democrat',
        'contest__candidate-row--winner rep--border':
          contestIsCalled && isWinner && party == 'Republican',
      }
    );

    let checkClass = cx('check', {
      'dem-winner': party == 'Democrat',
      'rep-winner': party == 'Republican',
      'runoff-winner': contestResult == 'runoff',
    });

    if (!isViewable) {
      rowClass += ' race__candidate-row--hidden';
    }

    const checkmark = '\u2713';

    return (
      <tr class={rowClass}>
        <td class="candidate__cell candidate__party">
          {party == 'Republican' && (
            <PartyPill party={party} style={divStyle} />
          )}
          {party == 'Democrat' && <PartyPill party={party} style={divStyle} />}
        </td>
        <th class="candidate__cell candidate__name">
          {contestIsCalled && isWinner && contestResult != 'runoff' && (
            <span class={checkClass} style={checkStyle}>
              {checkmark}
            </span>
          )}
          {contestIsCalled && isWinner && contestResult == 'runoff' && (
            <span class={checkClass} style={checkStyle}>
              {checkmark}
            </span>
          )}
          {contestIsCalled &&
          isWinner &&
          isCanvass == true &&
          contestResult != 'runoff' ? (
            <span class={checkClass}>{ballotName}</span>
          ) : (
            ballotName
          )}
          {IsAsterisk && <span class="asterisk">*</span>}{' '}
          {isIncumbent && (
            <span class="pill pill--basic" title="Currently holds this seat">
              Incumbent
            </span>
          )}
        </th>
        <td class="candidate__cell candidate__votes">{intcomma(votes)}</td>
        <td class="candidate__cell candidate__pct">
          {formatPercent(votes, totalVotesInContest)}
          <span class="candidate__pct-symbol">%</span>
        </td>
        {numDelegates && (
          <td class="candidate__cell candidate__votes">
            {
              numDelegates.find(cand => cand.candidate == ballotName)[
                'delegate-count'
              ]
            }
          </td>
        )}
      </tr>
    );
  }
}

HeadshotCandidateRow.defaultProps = {
  isIncumbent: false,
  isCalled: false,
  isWinner: false,
  isViewable: true,
};

HeadshotCandidateRow.Header = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Votes
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Pct.
        <span class="candidate__pct-symbol">%</span>
      </th>
    </tr>
  </thead>
);

HeadshotCandidateRow.Header_Prez = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Votes
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Pct.
        <span class="candidate__pct-symbol">%</span>
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Delegates
      </th>
    </tr>
  </thead>
);

HeadshotCandidateRow.columnCount = 6;

export default HeadshotCandidateRow;
